import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import routes from 'js/core_pre_webpack/routes';

import { ResearchInterest } from './types';

interface SearchResult {
  display_name: string;
  entity_slug: string;
  entity_url: string;
  id: string;
  type: string;
  weight: number;
  weight_description: string;
}

export async function search(
  query: string,
  risToExclude: Array<number>,
): Promise<Array<ResearchInterest>> {
  const response = await fetchWithCsrf(
    routes.search_tags_path({
      q: query,
      exclude_tags: JSON.stringify(risToExclude),
    }),
  );

  const body = await response.json();

  return body.results.map((result: SearchResult) => ({
    displayName: result.display_name,
    slug: result.entity_slug,
    url: result.entity_url,
    id: parseInt(result.id),
    weight: result.weight,
    weightDescription: result.weight_description,
  }));
}

export async function searchSubtopics(
  query: string,
  parentTopicId: number,
): Promise<Array<ResearchInterest>> {
  const response = await fetchWithCsrf(
    routes.search_subtopics_tags_path({
      q: query,
      parent_topic_id: parentTopicId,
    }),
  );

  const body = await response.json();

  return body.results.map((result: SearchResult) => ({
    displayName: result.display_name,
    slug: result.entity_slug,
    url: result.entity_url,
    id: parseInt(result.id),
    weight: result.weight,
    weightDescription: result.weight_description,
  }));
}
